import { faArrowsUpDown, faChevronLeft, faChevronRight, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import toast from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { SERVER_URL } from '../../../config';
import CountryList from '../../../country.json'

export default function MyNFT() {

    const Participation_Teams = [
        { Team_A: '/assets/teams/Team1.svg', Team_B: '/assets/teams/Team2.svg', date: 'July 20' },
        { Team_A: '/assets/teams/Team3.svg', Team_B: '/assets/teams/Team4.svg', date: 'July 20' },
        { Team_A: '/assets/teams/Team2.svg', Team_B: '/assets/teams/Team3.svg', date: 'July 20' },
    ]
    let token = sessionStorage.getItem('player_token')
    const navigate = useNavigate();
    const [playerData, setPlayerData] = useState([]);

    useEffect(() => {
        if (token) {
            get_player_data();
        }
    }, [token]);

    const get_player_data = async () => {
        try {
            const response = await axios.get(`${SERVER_URL}/api/v2/get-player-data`, {
                headers: { Authorization: `Bearer ${token}`, }
            });
            if (response.data.status === true) {
                setPlayerData(response.data.data);
            } else {
                setPlayerData([])
            }
        } catch (error) {
            console.error("Error checking the player profile : ", error);
            if (error.response?.status === 403) {
                toast.error(`${error?.response?.data?.error?.msg}`);
                setTimeout(() => {
                    toast.dismiss()
                    navigate('/player/Login');
                }, 1500);
            }
        }
    }

    const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
        <div
            {...props}
            className=" absolute z-10 top-1/2 transform -translate-y-1/2 left-0 w-5 h-5 rounded-full cursor-pointer duration-500 "
        >
            <div className="flex justify-center items-center w-full h-full">
                <FontAwesomeIcon icon={faChevronLeft} className="text-white font-bold" />
            </div>
        </div>
    );

    const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
        <div
            {...props}
            className=" absolute top-1/2 transform -translate-y-1/2 right-0 w-5 h-5 rounded-full cursor-pointer  duration-500 "
        >
            <div className="flex justify-center items-center w-full h-full">
                <FontAwesomeIcon icon={faChevronRight} className="text-white font-bold " />
            </div>
        </div>
    );

    const settings = {
        infinite: true,
        speed: 500,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: <SlickArrowLeft />,
        nextArrow: <SlickArrowRight />,
    };

    return (
        <div className='bg-[#D4D4D4]/10 rounded-tl-xl flex flex-col flex-grow py-5'>
            <div className='flex flex-col lg:flex-row gap-5 lg:gap-10 pl-5 lg:pl-10 pr-5 lg:pr-0 w-[100%]'>
                <div className='w-[100%] lg:w-[50%] flex flex-col md:flex-row items-center'>
                    <div className='w-[100%] md:w-[50%] flex items-center justify-center h-[320px] 2xl:h-[350px]'>
                        <img src='/assets/others/Playerinfo.svg' className='h-full object-cover'></img>
                    </div>
                    <div className='w-[100%] md:w-[50%] space-y-5'>
                        <div className='flex'>
                            <label className='text-primary font-bold w-[40%]'>Name:</label>
                            <p className='w-[60%] Capitalize'>{playerData?.full_name}</p>
                        </div>
                        <div className='flex'>
                            <label className='text-primary font-bold w-[40%]'>Position:</label>
                            <p className='w-[60%] Capitalize'>{playerData?.preferred_position}</p>
                        </div>
                        <div className='flex'>
                            <label className='text-primary font-bold w-[40%]'>Country:</label>
                            <p className="w-[60%] Capitalize flex items-center gap-2">
                                {CountryList.find((c) => c.label === playerData?.nationality) ? (
                                    <>
                                        <span className="text-2xl">
                                            {CountryList.find((c) => c.label === playerData?.nationality)?.country_flag}
                                        </span>
                                        {CountryList.find((c) => c.label === playerData?.nationality)?.label}
                                    </>
                                ) : (
                                    playerData?.nationality
                                )}
                            </p>
                        </div>
                        <div>
                            <label className='font-semibold'>Attributes</label>
                            <div className='mt-2 bg-[#D9D9D9]/15 rounded-lg px-5 py-3 flex justify-around font-medium'>
                                <div className='flex items-center gap-1'><img src='/assets/icon/Footwear.svg'></img> Left</div>
                                <div className='flex items-center gap-1'><FontAwesomeIcon icon={faArrowsUpDown} /> {playerData?.height} ft</div>
                            </div>
                        </div>

                        {playerData?.full_name?.toLowerCase() === "test" ? (
                            <div className='w-[100%] md:w-[100%] space-y-5'>
                                <div className=' flex items-center justify-between gap-3'>
                                    <h1 className='font-semibold text-3xl'>120</h1>
                                    <button className='border bg-black font-medium px-4 w-[50%] py-1 rounded-lg cursor-pointer'>Edit Profile</button>
                                </div>
                                <div className=' flex items-center justify-between gap-3'>
                                    <h1 className='font-semibold text-3xl'>GDX</h1>
                                    <button className='bg-white text-black font-medium w-[50%] px-4 py-1 rounded-lg cursor-pointer'>NFT Value</button>
                                </div>
                            </div>
                        ) : ''}
                    </div>
                </div>
                <div className='w-[100%] lg:w-[50%]'>
                    {playerData?.full_name?.toLowerCase() === "test" ? (
                        <div className='mb-3 border border-[#5A5A5A] bg-[#080808]/20 rounded-l-xl flex flex-col md:flex-row gap-5 lg:gap-0 items-center py-4 px-5'>
                            <div className='w-[100%] lg:w-[30%] text-center'>
                                <h1 className='font-semibold'>Availability: </h1>
                                <Slider className='w-40 mx-auto py-2' {...settings} >
                                    <div className='grid content-center'><img src='/assets/teams/Team1.svg' className='h-[75px] mx-auto'></img></div>
                                    <div className='grid content-center'><img src='/assets/teams/Team2.svg' className='h-[75px] mx-auto'></img></div>
                                </Slider>
                                <button className='px-5 lg:text-xs lg:py-1 rounded-md border bg-black'>View Schedule</button>
                            </div>
                            <div className='w-[100%] lg:w-[70%] text-center'>
                                <p>Are you available for the league</p>
                                <div className='flex justify-center gap-5 mt-2'>
                                    <button className='w-[30%] rounded-md text-black bg-white'>Yes</button>
                                    <button className='w-[30%] rounded-md border bg-black'>No</button>
                                </div>
                            </div>
                        </div>
                    ) : ''}

                    <div className={`lg:pr-10 lg:pl-0 ${playerData?.full_name?.toLowerCase() === "test" ? "" : "mt-10"}`}>
                        <h1 className='font-semibold'>Stats:</h1>
                        <div className='border border-[#5A5A5A] rounded-xl mt-3 bg-[#D9D9D9]/5 px-7 py-5 space-y-2'>
                            <div className='flex items-center justify-between'>
                                <div className='flex items-center gap-5'>
                                    <img src='/assets/icon/SoccerBall.svg'></img>
                                    <span className='text-[#7D7D7D] font-bold 2xl:text-lg'>Goals</span>
                                </div>
                                <p className='lg:w-[15%] text-center text-primary font-bold'>{playerData?.goals || '- - nil - -'}</p>
                            </div>
                            <div className='flex items-center justify-between'>
                                <div className='flex items-center gap-5'>
                                    <img src='/assets/icon/Soccer Player.svg'></img>
                                    <span className='text-[#7D7D7D] font-bold 2xl:text-lg'>Assist</span>
                                </div>
                                <p className='lg:w-[15%] text-center text-[#2EFFF2] font-bold'>{playerData?.assists || '- - nil - -'}</p>
                            </div>
                            <div className='flex items-center justify-between'>
                                <div className='flex items-center gap-5'>
                                    <img src='/assets/icon/Tackle.svg'></img>
                                    <span className='text-[#7D7D7D] font-bold 2xl:text-lg'>Tackle</span>
                                </div>
                                <p className='lg:w-[15%] text-center font-bold'>{playerData?.tackles || '- - nil - -'}</p>
                            </div>
                            <div className='flex items-center justify-between'>
                                <div className='flex items-center gap-5'>
                                    <img src='/assets/icon/Goalkeeper.svg'></img>
                                    <span className='text-[#7D7D7D] font-bold 2xl:text-lg'>Goal saves</span>
                                </div>
                                <p className='lg:w-[15%] text-center font-bold'>{playerData?.saves || '- - nil - -'}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {playerData?.full_name?.toLowerCase() === "test" ? (
                <div className='mt-5 px-5 lg:px-10'>
                    <div className='flex flex-col lg:flex-row items-center gap-3 lg:gap-0 lg:justify-between'>
                        <h1 className='font-semibold'>Past Participation:</h1>
                        <select className='bg-[#D9D9D9]/15 outline-none px-5 py-2 rounded-md'>
                            <option>Select League</option>
                            <option>UEFA Champions League</option>
                            <option>Premier League</option>
                        </select>
                    </div>
                    <div className={`mt-3 ${Participation_Teams.length > 0 ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-7' : ''}`}>
                        {Participation_Teams.length > 0 ? (
                            Participation_Teams.map((item, index) => (
                                <div key={index} className='border border-white p-3 rounded-xl flex items-center justify-around gap-3'>
                                    <img className='w-20 2xl:w-24' src={item.Team_A}></img>
                                    <p className='font-bold 2xl:text-lg'>{item.date}</p>
                                    <img className='w-20 2xl:w-24' src={item.Team_B}></img>
                                </div>
                            ))) : (
                            <div className='pt-5 text-xl font-bold'>
                                <p className='flex justify-center items-center '><FontAwesomeIcon icon={faMagnifyingGlass} className='mr-2 text-3xl' /> NO DATA</p>
                            </div>
                        )}
                    </div>

                </div>
            ) : ''}

        </div>
    )
}
